import React from 'react';
import { useDrag } from 'react-dnd';
import { EditIcon, DeleteIcon, GlobeIcon, StarIcon } from '../ui/Icons';
// --- INÍCIO DA ALTERAÇÃO 1: Importando o hook useData ---
import useData from '../../hooks/useData';
// --- FIM DA ALTERAÇÃO 1 ---

export const ItemTypes = { TOOL: 'tool' };

const ToolItem = ({ tool, onEdit, onDelete, viewMode }) => {
    // --- INÍCIO DA ALTERAÇÃO 2: Buscando a função para favoritar ---
    const { handleUpdateTool } = useData();
    // --- FIM DA ALTERAÇÃO 2 ---
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.TOOL,
        item: { id: tool.id, categoryId: tool.categoryId },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));

    const faviconUrl = `https://www.google.com/s2/favicons?domain=${tool.url}&sz=32`;

    // --- INÍCIO DA ALTERAÇÃO 3: Lógica para favoritar ---
    const handleToggleFavorite = (e) => {
        e.stopPropagation(); // Impede que o drag comece ao clicar na estrela
        e.preventDefault(); // Impede a navegação ao clicar na estrela
        handleUpdateTool(tool.id, { isFavorite: !tool.isFavorite });
    };
    // --- FIM DA ALTERAÇÃO 3 ---

    // --- INÍCIO DA ALTERAÇÃO 4: JSX condicional para renderizar a lista ou a grade ---
    if (viewMode === 'grid') {
        return (
            <div ref={drag} style={{ opacity: isDragging ? 0.4 : 1 }} className="relative group">
                <a href={tool.url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center p-4 bg-white/5 rounded-lg aspect-square transition-colors hover:bg-white/10" title={`${tool.name}\n${tool.description || ''}`}>
                    <img src={faviconUrl} alt={`Favicon for ${tool.name}`} className="w-8 h-8 object-contain" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                    <div className="absolute inset-0 hidden items-center justify-center bg-gray-700 rounded-md text-gray-400">
                        <GlobeIcon size={20} />
                    </div>
                    <p className="mt-2 text-xs text-center text-gray-300 truncate w-full">{tool.name}</p>
                </a>
                <div className="absolute top-1 right-1 flex flex-col gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button onClick={handleToggleFavorite} className="p-1.5 bg-gray-800/50 rounded-full hover:bg-gray-700"><StarIcon size={12} className={tool.isFavorite ? 'text-yellow-400' : 'text-white'} fill={tool.isFavorite ? 'currentColor' : 'none'} /></button>
                    <button onClick={() => onEdit(tool)} className="p-1.5 bg-gray-800/50 rounded-full hover:bg-gray-700"><EditIcon size={12} /></button>
                    <button onClick={() => onDelete(tool.id)} className="p-1.5 bg-gray-800/50 rounded-full hover:bg-gray-700"><DeleteIcon size={12} /></button>
                </div>
            </div>
        );
    }

    return (
        <div ref={drag} style={{ opacity: isDragging ? 0.4 : 1 }} className="relative group flex items-center gap-4 p-3 bg-white/5 rounded-lg transition-colors hover:bg-white/10">
            <a href={tool.url} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 relative w-8 h-8">
                <img 
                    src={faviconUrl} 
                    alt={`Favicon for ${tool.name}`} 
                    className="w-full h-full object-contain bg-gray-700 p-1 rounded-md" 
                    onError={(e) => { 
                        e.target.style.display = 'none'; 
                        if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                    }} 
                />
                <div className="absolute inset-0 hidden items-center justify-center bg-gray-700 rounded-md text-gray-400">
                    <GlobeIcon size={20} />
                </div>
            </a>

            <div className="flex-1 min-w-0">
                <a href={tool.url} target="_blank" rel="noopener noreferrer" className="block">
                    <p className="font-semibold text-white truncate">{tool.name}</p>
                    <p className="text-sm text-gray-400 truncate">{tool.description || 'Sem descrição'}</p>
                </a>
            </div>

            <div className="flex items-center gap-2">
                <button onClick={handleToggleFavorite} className="p-2 bg-transparent rounded-full text-gray-400 hover:text-yellow-400 transition-colors" title="Favoritar">
                    <StarIcon size={16} className={tool.isFavorite ? 'text-yellow-400' : ''} fill={tool.isFavorite ? 'currentColor' : 'none'}/>
                </button>
                <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button onClick={() => onEdit(tool)} className="p-2 bg-gray-800/50 rounded-full hover:bg-gray-700" title="Editar"><EditIcon size={16} /></button>
                    <button onClick={() => onDelete(tool.id)} className="p-2 bg-gray-800/50 rounded-full hover:bg-gray-700" title="Excluir"><DeleteIcon size={16} /></button>
                </div>
            </div>
        </div>
    );
    // --- FIM DA ALTERAÇÃO 4 ---
};

export default ToolItem;